import { useEffect } from 'react';
import useWidth from '../components/Hooks/useWidth';

interface BodyStyle extends CSSStyleDeclaration {
  zoom: number;
}

const useZoomGesture = () => {
  const { mobileWidth } = useWidth();

  useEffect(() => {
    if (mobileWidth) {
      const handleGestureStart = (e: Event) => {
        e.preventDefault();
        if (document.body.style) {
          (document.body.style as BodyStyle).zoom = 1;
        }
      };

      const handleGestureChange = (e: Event) => {
        e.preventDefault();
        if (document.body.style) {
          (document.body.style as BodyStyle).zoom = 1;
        }
      };

      const handleGestureEnd = (e: Event) => {
        e.preventDefault();
        if (document.body.style) {
          (document.body.style as BodyStyle).zoom = 1;
        }
      };

      document.addEventListener('gesturestart', handleGestureStart);
      document.addEventListener('gesturechange', handleGestureChange);
      document.addEventListener('gestureend', handleGestureEnd);

      return () => {
        document.removeEventListener('gesturestart', handleGestureStart);
        document.removeEventListener('gesturechange', handleGestureChange);
        document.removeEventListener('gestureend', handleGestureEnd);
      };
    }
  }, [mobileWidth]);
};

export default useZoomGesture;
